// src/services/complaintService.js
import apiClient from "./apiClient";
import axios from "axios";
import { BACKEND_URL } from "../utils/envConfig";

const API_URL = `/complaints`; // Use relative path since apiClient has baseURL
const BASE_URL = BACKEND_URL;

export const createComplaints = async (invoice) => {
  try {
    // apiClient will automatically add organizationId via interceptor
    const response = await apiClient.post(API_URL, invoice);
    return response.data;
  } catch (error) {
    console.error("Error creating invoice:", error);
    throw error;
  }
};

export const getComplainList = async () => {
  try {
    // Use axios directly to fetch from base table (without organizationId)
    // Complaints should come from common base table, not organization-specific table
    const token = localStorage.getItem("token");
    const response = await axios.get(`${BASE_URL}${API_URL}`, {
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching complain:", error);
    throw error;
  }
};
